import { Auth0ContextInterface } from '@auth0/auth0-react'
import { AxiosResponse, HttpStatusCode } from 'axios'
import { AuthedAxiosRequests } from 'features/auth'

function throwOnError(res: AxiosResponse): void {
  if (
    res.status !== (HttpStatusCode.Ok as number) &&
    res.status !== (HttpStatusCode.NoContent as number)
  ) {
    const error = new Error('An error occurred while fetching the data.')
    error.cause = res.data
    throw error
  }
}

export const getFetcher = async (
  url: string,
  auth0: Auth0ContextInterface,
  axios: AuthedAxiosRequests
) => {
  if (!url) return

  const res = await axios.get(url, {
    headers: { 'Content-Type': 'application/json' },
  })

  throwOnError(res)
  return await res.data
}

export const binaryFetcher = async (
  url: string,
  axios: AuthedAxiosRequests
) => {
  if (!url) return

  const res = await axios.get(url, {
    headers: { 'Content-Type': 'application/octet-stream' },
    responseType: 'arraybuffer',
  })

  throwOnError(res)

  return {
    data: await res.data,
    headers: res.headers,
  }
}

export const postFetcher = async (
  url: string | undefined,
  body: string,
  axios: AuthedAxiosRequests
) => {
  if (!url) return

  const res = await axios.post(url, body, {
    headers: { 'Content-Type': 'application/json' },
  })
  throwOnError(res)

  return await res.data
}
